const EleManagement = () => import("@/pages/electronic/index");
const EleList = () => import("@/pages/electronic/list");
const EleDetails = () => import("@/pages/electronic/details")

export default [
    {
        path: '/electronic-management',
        component: EleManagement,
        children: [
            {
                path: '',
                component: EleList,
                meta: [
                    {
                        name: '电子放行管理',
                        url: '/electronic-management'
                    }
                ]
            },
            {
                path: 'electronic-details/:id',
                component: EleDetails,
                meta: [
                    {
                        name: '电子放行管理',
                        url: '/electronic-management'
                    },
                    {
                        name: '放行申请记录',
                        url: ''
                    }
                ]
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/electronic.js